import React, { Component } from "react";
import {
  Typography,
  Box,
  Avatar,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { InfoOutlined, Group } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import myStyles from "./Style";
import { FirebaseContext } from "../../FirebaseInit";

const INIT_STATE = {
  img: null,
  loading: false,
  deleteDialog: false,
  blockDialog: false
};

class PrivateDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INIT_STATE,
      chat: props.dialogInfo
    };
    this.toggleDialog = this.toggleDialog.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
  }

  toggleDialog(e) {
    if (e.currentTarget.name === "delete")
      this.setState({ deleteDialog: true });
    else if (e.currentTarget.name === "block")
      this.setState({ blockDialog: true });
    else this.setState({ deleteDialog: false, blockDialog: false });
  }

  confirmDialog(firebase, e) {
    let name = e.currentTarget.name;
    if (name === "confirmDelete") {
      firebase
        .fs()
        .collection("chats")
        .doc(this.state.chat.id)
        .set(
          {
            activeMembers: firebase.fs.FieldValue.arrayRemove(
              this.props.user.email
            ),
            membersInfo: {
              [this.props.user.uid]: { joined: firebase.fs.Timestamp.now() }
            }
          },
          { merge: true }
        )
        .then(() => {
          this.setState({ deleteDialog: false });
          this.props.chatDeleted();
          this.props.toggleAlert("Chat deleted.", "success");
        })
        .catch(err => {
          console.log(err);
          this.setState({ deleteDialog: false });
          this.props.toggleAlert(
            "Error deleting chat.Please try again",
            "error"
          );
        });
    } else {
      let blockStatus =
        this.props.dialogInfo.blocked.indexOf(this.props.dialogInfo.uid) > -1
          ? true
          : false;
      let query = blockStatus
        ? firebase.fs.FieldValue.arrayRemove(this.state.chat.uid)
        : firebase.fs.FieldValue.arrayUnion(this.state.chat.uid);
      firebase
        .fs()
        .collection("chats")
        .doc(this.state.chat.id)
        .update({
          blocked: query
        })
        .then(() => {
          this.setState({ blockDialog: false });
          this.props.toggleAlert("Contact blocked.", "success");
        })
        .catch(err => {
          this.setState({ blockDialog: false });
          this.props.toggleAlert("An error occured. Please try again", "error");
        });
    }
  }

  render() {
    const { classes } = this.props;
    const firebase = this.context;
    return (
      <>
        <Typography variant="h6" color="primary">
          Profile picture
        </Typography>
        <Box p={2} display="flex" alignItems="center" justifyContent="center">
          <Avatar src={this.state.chat.ppURL} className={classes.avatar}>
            <Group />
          </Avatar>
        </Box>
        <Divider />
        <Typography variant="h6" color="primary">
          Name
        </Typography>
        <Typography paragraph>{this.state.chat.username}</Typography>
        <Divider />
        <Typography color="primary" variant="h6">
          Email
        </Typography>
        <Typography paragraph color="textSecondary" variant="body1">
          {this.state.chat.email}
        </Typography>
        <Divider />
        <Box
          mb={1}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Typography variant="h6" color="primary">
            Delete Chat
          </Typography>
          <Box mb={2} display="flex" alignItems="center">
            <InfoOutlined
              style={{ fontSize: 17, marginRight: "10px" }}
              color="secondary"
            />
            <Typography color="secondary" variant="caption">
              You will lose all the messages.
            </Typography>
          </Box>

          <Button
            disabled={this.state.loading}
            onClick={this.toggleDialog}
            color="secondary"
            variant="contained"
            name="delete"
            size="small"
            style={{ width: "max-content" }}
          >
            Delete Chat
          </Button>
        </Box>
        <Divider />
        <Box display="flex" justifyContent="center" flexDirection="column">
          <Typography variant="h6" color="primary">
            Block user
          </Typography>
          <Box mb={2} display="flex" alignItems="center">
            <InfoOutlined
              style={{ fontSize: 17, marginRight: "10px" }}
              color="secondary"
            />
            <Typography color="secondary" variant="caption">
              You will no longer receive messages from this user.
            </Typography>
          </Box>

          <Button
            disabled={this.state.loading}
            onClick={this.toggleDialog}
            color="secondary"
            variant="contained"
            name="block"
            size="small"
            style={{ width: "max-content" }}
          >
            {this.props.dialogInfo.blocked &&
            this.props.dialogInfo.blocked.indexOf(this.props.dialogInfo.uid) >
              -1
              ? "Unblock"
              : "Block"}
          </Button>
        </Box>

        <Dialog
          open={this.state.deleteDialog || this.state.blockDialog}
          onClose={this.toggleDialog}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          style={{ zIndex: 1350 }}
        >
          <DialogTitle>
            {this.state.deleteDialog && "Delete chat"}
            {this.state.blockDialog && "Block user"}
          </DialogTitle>
          <DialogContent>
            <Typography>Are you sure?</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.loading}
              color="primary"
              onClick={this.toggleDialog}
              name="cancel"
            >
              Cancel
            </Button>
            <Button
              disabled={this.state.loading}
              color="secondary"
              onClick={this.confirmDialog.bind(this, firebase)}
              name={this.state.deleteDialog ? "confirmDelete" : "confirmBlock"}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}
PrivateDialog.contextType = FirebaseContext;
export default withStyles(myStyles)(PrivateDialog);
